import styled from 'styled-components';

export default styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 4rem;
  margin-bottom: 4rem;
`;
